/* ═══════════════════════════════════════════════════════════════════════════
   Urrykid — Shopify theme interactions
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  // ── FAQ toggle ────────────────────────────────────────────────────────────
  document.querySelectorAll(".faq-q").forEach(function (btn) {
    btn.addEventListener("click", function () {
      btn.parentElement.classList.toggle("open");
    });
  });

  // ── Search overlay (homepage) ─────────────────────────────────────────────
  var overlay = document.getElementById("search-overlay");
  if (overlay) {
    var openBtn = document.getElementById("btn-search-open");
    var closeBtn = document.getElementById("btn-search-close");
    if (openBtn) {
      openBtn.addEventListener("click", function () {
        overlay.classList.add("open");
        var input = document.getElementById("search-input");
        if (input) input.focus();
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", function () { overlay.classList.remove("open"); });
    }
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) overlay.classList.remove("open");
    });
  }

  // ── Filter drawer (collection) ────────────────────────────────────────────
  var backdrop = document.getElementById("drawer-backdrop");
  var drawer = document.getElementById("filter-drawer");
  var openFilterBtn = document.getElementById("btn-open-filter");

  window.openDrawer = function () {
    if (drawer) drawer.classList.add("open");
    if (backdrop) backdrop.classList.add("open");
    document.body.style.overflow = "hidden";
  };
  window.closeDrawer = function () {
    if (drawer) drawer.classList.remove("open");
    if (backdrop) backdrop.classList.remove("open");
    document.body.style.overflow = "";
  };
  if (openFilterBtn) openFilterBtn.addEventListener("click", openDrawer);
  if (backdrop) backdrop.addEventListener("click", closeDrawer);

  // ── Product gallery ───────────────────────────────────────────────────────
  window.setImage = function (url, el) {
    var main = document.getElementById("pdp-main-img");
    if (main) main.src = url;
    if (el) {
      var group = el.parentElement;
      if (group) {
        group.querySelectorAll("button").forEach(function (b) { b.classList.remove("active"); });
        el.classList.add("active");
      }
    }
  };

  // ── Swipe to switch images (mobile) ───────────────────────────────────────
  var galleryWrap = document.querySelector(".pdp-main-img-wrap");
  if (galleryWrap) {
    var touchX = 0;
    galleryWrap.addEventListener("touchstart", function (e) {
      touchX = e.changedTouches[0].screenX;
    }, { passive: true });
    galleryWrap.addEventListener("touchend", function (e) {
      var delta = touchX - e.changedTouches[0].screenX;
      if (Math.abs(delta) < 40) return;
      var dots = document.querySelectorAll(".pdp-mobile-dots button");
      if (!dots.length) return;
      var active = -1;
      dots.forEach(function (d, i) { if (d.classList.contains("active")) active = i; });
      var next = delta > 0 ? active + 1 : active - 1;
      if (next >= 0 && next < dots.length) dots[next].click();
    }, { passive: true });
  }

  // ── Thumbnails height sync + scroll arrows ────────────────────────────────
  function syncThumbsHeight() {
    var main = document.querySelector(".pdp-main-img-wrap");
    var col = document.querySelector(".pdp-thumbs-col");
    var scroller = document.getElementById("pdp-thumbs");
    if (!main || !col || !scroller) return;
    var arrowsH = 0;
    col.querySelectorAll(".pdp-thumbs-arrow").forEach(function (a) { arrowsH += a.offsetHeight; });
    var gaps = 16; // 2 gaps × 8px
    scroller.style.maxHeight = Math.max(0, main.offsetHeight - arrowsH - gaps) + "px";
  }

  window.scrollThumbs = function (dir) {
    var scroller = document.getElementById("pdp-thumbs");
    if (!scroller) return;
    var first = scroller.querySelector("button");
    var step = first ? first.offsetHeight + 8 : 88;
    scroller.scrollBy({ top: dir * step, behavior: "smooth" });
  };

  function initThumbsSync() {
    syncThumbsHeight();
    var mainImg = document.getElementById("pdp-main-img");
    if (mainImg) mainImg.addEventListener("load", syncThumbsHeight);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initThumbsSync);
    window.addEventListener("load", syncThumbsHeight);
  } else {
    initThumbsSync();
  }
  window.addEventListener("resize", syncThumbsHeight);

  // ── Quantity stepper ──────────────────────────────────────────────────────
  window.changeQty = function (delta) {
    var input = document.getElementById("quantity");
    var display = document.getElementById("qty-display");
    if (!input) return;
    var v = parseInt(input.value || "1", 10) + delta;
    if (v < 1) v = 1;
    input.value = v;
    if (display) display.textContent = v;
  };

  // ── Product tabs ──────────────────────────────────────────────────────────
  document.querySelectorAll(".pdp-tab-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      document.querySelectorAll(".pdp-tab-btn").forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      var id = btn.getAttribute("data-tab");
      document.querySelectorAll(".pdp-tab-content").forEach(function (c) { c.style.display = "none"; });
      var target = document.getElementById("tab-" + id);
      if (target) target.style.display = "";
    });
  });

  // ── Variant picker ────────────────────────────────────────────────────────
  function readChosenOptions() {
    var chosen = [];
    document.querySelectorAll(".option-value").forEach(function (input) {
      chosen.push(input.value);
    });
    return chosen;
  }

  window.selectOption = function (el) {
    var idx = el.getAttribute("data-option-index");
    var val = el.getAttribute("data-value") || el.value;
    var hidden = document.querySelector('.option-value[data-index="' + idx + '"]');
    if (hidden) hidden.value = val;

    // Update the option label ("Color: Red" → "Color: Blue")
    var section = el.closest(".pdp-section");
    if (section) {
      var label = section.querySelector(".pdp-section-label .val");
      if (label) label.textContent = val;
    }

    if (el.classList && el.classList.contains("pdp-color-btn")) {
      var group = el.parentElement;
      if (group) {
        group.querySelectorAll(".pdp-color-btn").forEach(function (b) { b.classList.remove("active"); });
        el.classList.add("active");
      }
    }
    window.updateVariant();
  };

  window.updateVariant = function () {
    var dataEl = document.getElementById("variants-data");
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var chosen = readChosenOptions();

    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (!match) return;

    var idInput = document.getElementById("variant-id");
    if (idInput) idInput.value = match.id;

    var priceEl = document.getElementById("pdp-price");
    if (priceEl) priceEl.textContent = formatMoney(match.price);

    var cmp = document.getElementById("pdp-compare");
    if (cmp) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        cmp.textContent = formatMoney(match.compare_at_price);
        cmp.style.display = "";
      } else {
        cmp.style.display = "none";
      }
    }
  };

  function formatMoney(cents) {
    var fmt = (window.URRYKID && window.URRYKID.moneyFormat) || "${{amount}}";
    var val = ((cents || 0) / 100).toFixed(2);
    return fmt.replace("{{amount}}", val);
  }
})();
